/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sub2": {
        "nested": {
          "assets": {
            "nested": {
              "PlanText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PlanTextList": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PlanFeatureText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 2,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FeatureImage": {
                "fields": {
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FeatureText": {
                "fields": {
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TextIcon": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "iconName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PlanTextAndIconList": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "textAndIcon": {
                    "type": ".squareup.sub2.assets.TextIcon",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "Viewport": {
                "values": {
                  "DO_NOT_USE_VIEWPORT": 0,
                  "DESKTOP": 1,
                  "MOBILE": 2
                }
              },
              "Image": {
                "fields": {
                  "url": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "recommendedViewport": {
                    "type": ".squareup.sub2.assets.Viewport",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FullPagePaywall": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "image": {
                    "type": ".squareup.sub2.assets.FeatureImage",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 7,
                    "rule": "repeated"
                  }
                }
              },
              "Modal": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "headerTrialOne": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "headerTrialOther": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "includes": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "ctaStartTrial": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "ctaUpgrade": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "learnMoreText": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "moreFeaturesText": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "moreFeaturesLinkText": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 15,
                    "rule": "repeated"
                  },
                  "moreFeaturesLink": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 16,
                    "rule": "repeated"
                  }
                }
              },
              "Disclaimer": {
                "fields": {
                  "oblTrialDisabledAvailableTrialText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "oblTrialDisabledUnavailableTrialText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "unavailableTrialWithPricePerLocText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "unavailableTrialWithoutPricePerLocText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "availableOblTrialWithPricePerLocText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "availableOblTrialWithoutPricePerLocText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "defaultText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  }
                }
              },
              "Pill": {
                "fields": {
                  "ineligibleText": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "includedText": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "eligibleText": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "PaywallCard": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "tryOne": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tryOther": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "Downgrade": {
                "fields": {}
              },
              "TrialWelcome": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "image": {
                    "type": ".squareup.sub2.assets.Image",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tryFeatures": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "exclusiveFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "TrialExpiring": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "subscribeToKeep": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "exclusiveFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "TrialExpired": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "subscribeToKeep": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "exclusiveFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "MigrationOptIn": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "image": {
                    "type": ".squareup.sub2.assets.Image",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "cardRequiredDisclaimer": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "viewAllFeaturesUrl": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "includedFeaturesHeader": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "PlanPromotionalPricingText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "defaultPricing": {
                    "type": ".squareup.sub2.data.LocalizedHeadlinePlanPricing",
                    "id": 2,
                    "rule": "optional"
                  },
                  "promotionalPricing": {
                    "type": ".squareup.sub2.data.LocalizedHeadlinePlanPricing",
                    "id": 3,
                    "rule": "optional"
                  },
                  "discountRate": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "promotionalPricingDisclaimer": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "MigrationOptOut": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "paragraph2": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextAndIconList",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "exploreAllFeaturesUrl": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "footer": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "processingFeesUrl": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "planPromotionalPricingText": {
                    "type": ".squareup.sub2.assets.PlanPromotionalPricingText",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "featureCallouts": {
                    "type": ".squareup.sub2.assets.PlanFeatureCalloutList",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "planDefaultPricingText": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "DefaultProcessingFees": {
                "fields": {
                  "cardPresentRateName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardNotPresentRateName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "onlineRateName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "onlineApiRateName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "achApiRateName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "achInvoicesRateName": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "afterpayRateName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "giftCardLoadRateName": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "appSubscriptionsRateName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "achAppSubscriptionsRateName": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "appSubscriptionsMarketplaceRateName": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cashBusinessRateName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "internalAccountsRateName": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "costPlusMarginRateName": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "interchangePlusMarginRateName": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "freeRateName": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "cardPresentRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "cardNotPresentRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 18,
                    "rule": "repeated"
                  },
                  "onlineRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 19,
                    "rule": "repeated"
                  },
                  "onlineApiRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "achApiRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 21,
                    "rule": "repeated"
                  },
                  "achInvoicesRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 22,
                    "rule": "repeated"
                  },
                  "afterpayRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 23,
                    "rule": "repeated"
                  },
                  "giftCardLoadRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 24,
                    "rule": "repeated"
                  },
                  "appSubscriptionsRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 25,
                    "rule": "repeated"
                  },
                  "achAppSubscriptionsRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 26,
                    "rule": "repeated"
                  },
                  "appSubscriptionsMarketplaceRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 27,
                    "rule": "repeated"
                  },
                  "cashBusinessRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 28,
                    "rule": "repeated"
                  },
                  "internalAccountsRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 29,
                    "rule": "repeated"
                  },
                  "costPlusMarginRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 30,
                    "rule": "repeated"
                  },
                  "interchangePlusMarginRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 31,
                    "rule": "repeated"
                  },
                  "freeRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 32,
                    "rule": "repeated"
                  }
                }
              },
              "FeatureLoss": {
                "fields": {
                  "features": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PricingCategory": {
                "fields": {
                  "category": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subcategories": {
                    "type": ".squareup.sub2.assets.PricingSubCategory",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PricingSubCategory": {
                "fields": {
                  "subcategory": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "features": {
                    "type": ".squareup.sub2.assets.PricingFeature",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PricingFeature": {
                "fields": {
                  "feature": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tooltip": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "includedFree": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includedPlus": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "includedPremium": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "freeText": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "plusText": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "premiumText": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "FeatureGrid": {
                "fields": {
                  "categories": {
                    "type": ".squareup.sub2.assets.PricingCategory",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FaqTableValue": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FaqTableRow": {
                "fields": {
                  "rowHeader": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "values": {
                    "type": ".squareup.sub2.assets.FaqTableValue",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "FaqTable": {
                "fields": {
                  "columnHeaders": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "rows": {
                    "type": ".squareup.sub2.assets.FaqTableRow",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "titleSegments": {
                    "type": ".squareup.sub2.assets.FaqTextSegment",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "footnoteSegments": {
                    "type": ".squareup.sub2.assets.FaqTextSegment",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "FaqExampleItem": {
                "fields": {
                  "header": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FaqExamples": {
                "fields": {
                  "introText": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "items": {
                    "type": ".squareup.sub2.assets.FaqExampleItem",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "FaqLink": {
                "fields": {
                  "url": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "external": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FaqTextSegment": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "link": {
                    "type": ".squareup.sub2.assets.FaqLink",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FaqParagraph": {
                "fields": {
                  "segments": {
                    "type": ".squareup.sub2.assets.FaqTextSegment",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FaqAnswer": {
                "fields": {
                  "paragraphs": {
                    "type": ".squareup.sub2.assets.FaqParagraph",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "table": {
                    "type": ".squareup.sub2.assets.FaqTable",
                    "id": 2,
                    "rule": "optional"
                  },
                  "examples": {
                    "type": ".squareup.sub2.assets.FaqExamples",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FaqItem": {
                "fields": {
                  "question": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "answer": {
                    "type": ".squareup.sub2.assets.FaqAnswer",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FeatureCallout": {
                "fields": {
                  "iconUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "title": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PlanFeatureCalloutList": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "callouts": {
                    "type": ".squareup.sub2.assets.FeatureCallout",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "TrialCountdown": {
                "fields": {
                  "comparePlansText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "subscribeButtonText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "trialEndsText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "trialEndsTodayText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "trialEndedText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "trialActiveDescription": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "trialExpiredDescription": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "featureListHeader": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 9,
                    "rule": "repeated"
                  }
                }
              },
              "ActivationConfirmation": {
                "fields": {
                  "ctaBackToPos": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "ctaContinue": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "headerText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "bodyText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "PreviewBanner": {
                "fields": {
                  "labelText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ProductTipsModalSlide": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isPaidFeature": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "featureKey": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ProductTipsModalVariant": {
                "values": {
                  "PRODUCT_TIPS_MODAL_VARIANT_LEGACY_SAAS": 0,
                  "PRODUCT_TIPS_MODAL_VARIANT_LEGACY_HOLDOUT": 1,
                  "PRODUCT_TIPS_MODAL_VARIANT_NEW_FREE": 2,
                  "PRODUCT_TIPS_MODAL_VARIANT_NEW_SAAS": 3
                }
              },
              "ProductTipsModal": {
                "fields": {
                  "slides": {
                    "type": ".squareup.sub2.assets.ProductTipsModalSlide",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "header": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ctaPrimary": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "ctaSecondary": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "variant": {
                    "type": ".squareup.sub2.assets.ProductTipsModalVariant",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ProductTipsTile": {
                "fields": {
                  "header": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ctaPrimary": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PlanSelection": {
                "fields": {
                  "heroEyebrow": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "heroTitle": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "heroDescription": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "planNames": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "strikethroughPricingDisclaimer": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "recurrencyTextFallback": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "strikethroughCostPerMonthText": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "processingFeesTitle": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 30,
                    "rule": "repeated"
                  },
                  "processingFeesInPersonLabelFallback": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "processingFeesOnlineLabelFallback": {
                    "type": "string",
                    "id": 32,
                    "rule": "optional"
                  },
                  "processingFeesDisclaimer": {
                    "type": "string",
                    "id": 33,
                    "rule": "optional"
                  },
                  "featureCallouts": {
                    "type": ".squareup.sub2.assets.PlanFeatureCalloutList",
                    "id": 40,
                    "rule": "repeated"
                  },
                  "featureCalloutCurrentlyUsingLabel": {
                    "type": "string",
                    "id": 41,
                    "rule": "optional"
                  },
                  "ctaCurrentPlan": {
                    "type": "string",
                    "id": 50,
                    "rule": "optional"
                  },
                  "ctaPendingDowngrade": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 51,
                    "rule": "repeated"
                  },
                  "ctaTryFreeOne": {
                    "type": "string",
                    "id": 52,
                    "rule": "optional"
                  },
                  "ctaTryFreeOther": {
                    "type": "string",
                    "id": 53,
                    "rule": "optional"
                  },
                  "ctaUsePlan": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 54,
                    "rule": "repeated"
                  },
                  "ctaSubscribe": {
                    "type": "string",
                    "id": 55,
                    "rule": "optional"
                  },
                  "ctaFinishLater": {
                    "type": "string",
                    "id": 56,
                    "rule": "optional"
                  },
                  "recommendedBadge": {
                    "type": "string",
                    "id": 60,
                    "rule": "optional"
                  },
                  "trialDaysLeftOne": {
                    "type": "string",
                    "id": 61,
                    "rule": "optional"
                  },
                  "trialDaysLeftOther": {
                    "type": "string",
                    "id": 62,
                    "rule": "optional"
                  },
                  "trialEndsToday": {
                    "type": "string",
                    "id": 63,
                    "rule": "optional"
                  },
                  "pendingDowngrade": {
                    "type": "string",
                    "id": 64,
                    "rule": "optional"
                  },
                  "pendingDowngradeToday": {
                    "type": "string",
                    "id": 65,
                    "rule": "optional"
                  },
                  "compareFeaturesTitle": {
                    "type": "string",
                    "id": 70,
                    "rule": "optional"
                  },
                  "yourSubscriptionsTitle": {
                    "type": "string",
                    "id": 71,
                    "rule": "optional"
                  },
                  "exploreFurtherText": {
                    "type": "string",
                    "id": 80,
                    "rule": "optional"
                  },
                  "exploreFurtherLinkUrl": {
                    "type": "string",
                    "id": 81,
                    "rule": "optional"
                  },
                  "exploreFurtherLinkText": {
                    "type": "string",
                    "id": 85,
                    "rule": "optional"
                  },
                  "additionalFeesText": {
                    "type": "string",
                    "id": 82,
                    "rule": "optional"
                  },
                  "additionalFeesLinkText": {
                    "type": "string",
                    "id": 83,
                    "rule": "optional"
                  },
                  "additionalFeesLinkUrl": {
                    "type": "string",
                    "id": 84,
                    "rule": "optional"
                  },
                  "supportSectionTitle": {
                    "type": "string",
                    "id": 90,
                    "rule": "optional"
                  },
                  "chatEmailSupportText": {
                    "type": "string",
                    "id": 91,
                    "rule": "optional"
                  },
                  "phoneSupportText": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 92,
                    "rule": "repeated"
                  },
                  "heroBackgroundImage": {
                    "type": ".squareup.sub2.assets.Image",
                    "id": 100,
                    "rule": "optional"
                  },
                  "altBackArrow": {
                    "type": "string",
                    "id": 110,
                    "rule": "optional"
                  },
                  "altClose": {
                    "type": "string",
                    "id": 111,
                    "rule": "optional"
                  },
                  "altCheckmark": {
                    "type": "string",
                    "id": 112,
                    "rule": "optional"
                  },
                  "commonError": {
                    "type": "string",
                    "id": 120,
                    "rule": "optional"
                  },
                  "commonContinue": {
                    "type": "string",
                    "id": 121,
                    "rule": "optional"
                  },
                  "commonCancel": {
                    "type": "string",
                    "id": 122,
                    "rule": "optional"
                  },
                  "commonOk": {
                    "type": "string",
                    "id": 123,
                    "rule": "optional"
                  },
                  "commonFree": {
                    "type": "string",
                    "id": 124,
                    "rule": "optional"
                  },
                  "commonPerLocation": {
                    "type": "string",
                    "id": 125,
                    "rule": "optional"
                  },
                  "faqs": {
                    "type": ".squareup.sub2.assets.FaqItem",
                    "id": 130,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanTextList && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanFeatureText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureImage && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TextIcon && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanTextAndIconList && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Viewport && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Image && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FullPagePaywall && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Modal && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Disclaimer && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Pill && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PaywallCard && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Downgrade && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TrialWelcome && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TrialExpiring && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TrialExpired && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.MigrationOptIn && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanPromotionalPricingText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.MigrationOptOut && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.DefaultProcessingFees && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureLoss && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PricingCategory && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PricingSubCategory && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PricingFeature && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureGrid && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqTableValue && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqTableRow && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqTable && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqExampleItem && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqExamples && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqLink && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqTextSegment && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqParagraph && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqAnswer && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FaqItem && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureCallout && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanFeatureCalloutList && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TrialCountdown && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.ActivationConfirmation && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PreviewBanner && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.ProductTipsModalSlide && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.ProductTipsModalVariant && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.ProductTipsModal && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.ProductTipsTile && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanSelection) {
  $root.addJSON(jsonData);
}

/**
 * Text specific to a particular plan.
 *
 * SOURCE PlanText @ squareup/sub2/assets.proto at 11:1
 */
export const PlanText = $root.lookupType('squareup.sub2.assets.PlanText');
fixType(PlanText);
Builder.createAndAttachToType(PlanText);
/**
 * Multi-line text specific to a particular plan.
 *
 * SOURCE PlanTextList @ squareup/sub2/assets.proto at 19:1
 */
export const PlanTextList = $root.lookupType('squareup.sub2.assets.PlanTextList');
fixType(PlanTextList);
Builder.createAndAttachToType(PlanTextList);
/**
 * Text specific to a particular (plan, feature) tuple.
 *
 * SOURCE PlanFeatureText @ squareup/sub2/assets.proto at 27:1
 */
export const PlanFeatureText = $root.lookupType('squareup.sub2.assets.PlanFeatureText');
fixType(PlanFeatureText);
Builder.createAndAttachToType(PlanFeatureText);
/**
 * Image specific to a particular feature.
 *
 * SOURCE FeatureImage @ squareup/sub2/assets.proto at 36:1
 */
export const FeatureImage = $root.lookupType('squareup.sub2.assets.FeatureImage');
fixType(FeatureImage);
Builder.createAndAttachToType(FeatureImage);
/**
 * Text specific to a particular feature.
 *
 * SOURCE FeatureText @ squareup/sub2/assets.proto at 44:1
 */
export const FeatureText = $root.lookupType('squareup.sub2.assets.FeatureText');
fixType(FeatureText);
Builder.createAndAttachToType(FeatureText);
/**
 * A paired text and Market icon. Useful for things like lists
 * of features with unique icons for bullets.
 *
 * SOURCE TextIcon @ squareup/sub2/assets.proto at 53:1
 */
export const TextIcon = $root.lookupType('squareup.sub2.assets.TextIcon');
fixType(TextIcon);
Builder.createAndAttachToType(TextIcon);
/**
 * A list of paired icons and text specific to a particular plan.
 *
 * SOURCE PlanTextAndIconList @ squareup/sub2/assets.proto at 62:1
 */
export const PlanTextAndIconList = $root.lookupType('squareup.sub2.assets.PlanTextAndIconList');
fixType(PlanTextAndIconList);
Builder.createAndAttachToType(PlanTextAndIconList);
/**
 * SOURCE Viewport @ squareup/sub2/assets.proto at 67:1
 */
export const Viewport = $root.lookupEnum('squareup.sub2.assets.Viewport').values;
/**
 * Standard Image.
 *
 * SOURCE Image @ squareup/sub2/assets.proto at 76:1
 */
export const Image = $root.lookupType('squareup.sub2.assets.Image');
fixType(Image);
Builder.createAndAttachToType(Image);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE FullPagePaywall @ squareup/sub2/assets.proto at 84:1
 */
export const FullPagePaywall = $root.lookupType('squareup.sub2.assets.FullPagePaywall');
fixType(FullPagePaywall);
Builder.createAndAttachToType(FullPagePaywall);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE Modal @ squareup/sub2/assets.proto at 97:1
 */
export const Modal = $root.lookupType('squareup.sub2.assets.Modal');
fixType(Modal);
Builder.createAndAttachToType(Modal);
/**
 * Disclaimer text for upsell flows, covering trial availability and pricing scenarios.
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE Disclaimer @ squareup/sub2/assets.proto at 120:1
 */
export const Disclaimer = $root.lookupType('squareup.sub2.assets.Disclaimer');
fixType(Disclaimer);
Builder.createAndAttachToType(Disclaimer);
/**
 * Pill text for upsell feature badges, indicating tier eligibility and trial status.
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE Pill @ squareup/sub2/assets.proto at 134:1
 */
export const Pill = $root.lookupType('squareup.sub2.assets.Pill');
fixType(Pill);
Builder.createAndAttachToType(Pill);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE PaywallCard @ squareup/sub2/assets.proto at 143:1
 */
export const PaywallCard = $root.lookupType('squareup.sub2.assets.PaywallCard');
fixType(PaywallCard);
Builder.createAndAttachToType(PaywallCard);
/**
 * SOURCE Downgrade @ squareup/sub2/assets.proto at 154:1
 */
export const Downgrade = $root.lookupType('squareup.sub2.assets.Downgrade');
fixType(Downgrade);
Builder.createAndAttachToType(Downgrade);
/**
 * SOURCE TrialWelcome @ squareup/sub2/assets.proto at 156:1
 */
export const TrialWelcome = $root.lookupType('squareup.sub2.assets.TrialWelcome');
fixType(TrialWelcome);
Builder.createAndAttachToType(TrialWelcome);
/**
 * SOURCE TrialExpiring @ squareup/sub2/assets.proto at 165:1
 */
export const TrialExpiring = $root.lookupType('squareup.sub2.assets.TrialExpiring');
fixType(TrialExpiring);
Builder.createAndAttachToType(TrialExpiring);
/**
 * SOURCE TrialExpired @ squareup/sub2/assets.proto at 173:1
 */
export const TrialExpired = $root.lookupType('squareup.sub2.assets.TrialExpired');
fixType(TrialExpired);
Builder.createAndAttachToType(TrialExpired);
/**
 * SOURCE MigrationOptIn @ squareup/sub2/assets.proto at 181:1
 */
export const MigrationOptIn = $root.lookupType('squareup.sub2.assets.MigrationOptIn');
fixType(MigrationOptIn);
Builder.createAndAttachToType(MigrationOptIn);
/**
 * Represents the localized promotional pricing information.
 *
 * SOURCE PlanPromotionalPricingText @ squareup/sub2/assets.proto at 193:1
 */
export const PlanPromotionalPricingText = $root.lookupType('squareup.sub2.assets.PlanPromotionalPricingText');
fixType(PlanPromotionalPricingText);
Builder.createAndAttachToType(PlanPromotionalPricingText);
/**
 * SOURCE MigrationOptOut @ squareup/sub2/assets.proto at 207:1
 */
export const MigrationOptOut = $root.lookupType('squareup.sub2.assets.MigrationOptOut');
fixType(MigrationOptOut);
Builder.createAndAttachToType(MigrationOptOut);
/**
 * Assets related to default (i.e. not seller-specific) processing fees
 *
 * SOURCE DefaultProcessingFees @ squareup/sub2/assets.proto at 230:1
 */
export const DefaultProcessingFees = $root.lookupType('squareup.sub2.assets.DefaultProcessingFees');
fixType(DefaultProcessingFees);
Builder.createAndAttachToType(DefaultProcessingFees);
/**
 * SOURCE FeatureLoss @ squareup/sub2/assets.proto at 297:1
 */
export const FeatureLoss = $root.lookupType('squareup.sub2.assets.FeatureLoss');
fixType(FeatureLoss);
Builder.createAndAttachToType(FeatureLoss);
/**
 * A category of features. Ex: Payments & Checkout
 *
 * SOURCE PricingCategory @ squareup/sub2/assets.proto at 316:1
 */
export const PricingCategory = $root.lookupType('squareup.sub2.assets.PricingCategory');
fixType(PricingCategory);
Builder.createAndAttachToType(PricingCategory);
/**
 * A subcategory of features. Ex: Payment Methods
 *
 * SOURCE PricingSubCategory @ squareup/sub2/assets.proto at 322:1
 */
export const PricingSubCategory = $root.lookupType('squareup.sub2.assets.PricingSubCategory');
fixType(PricingSubCategory);
Builder.createAndAttachToType(PricingSubCategory);
/**
 * Represents the availability and pricing information of a feature across Square One plans
 *
 * SOURCE PricingFeature @ squareup/sub2/assets.proto at 328:1
 */
export const PricingFeature = $root.lookupType('squareup.sub2.assets.PricingFeature');
fixType(PricingFeature);
Builder.createAndAttachToType(PricingFeature);
/**
 * Represents the feature comparison grid for Square One plans
 *
 * SOURCE FeatureGrid @ squareup/sub2/assets.proto at 340:1
 */
export const FeatureGrid = $root.lookupType('squareup.sub2.assets.FeatureGrid');
fixType(FeatureGrid);
Builder.createAndAttachToType(FeatureGrid);
/**
 * A value in a FAQ table that can be either simple text or plan-specific.
 *
 * SOURCE FaqTableValue @ squareup/sub2/assets.proto at 347:1
 */
export const FaqTableValue = $root.lookupType('squareup.sub2.assets.FaqTableValue');
fixType(FaqTableValue);
Builder.createAndAttachToType(FaqTableValue);
/**
 * A row in a FAQ table.
 *
 * SOURCE FaqTableRow @ squareup/sub2/assets.proto at 357:1
 */
export const FaqTableRow = $root.lookupType('squareup.sub2.assets.FaqTableRow');
fixType(FaqTableRow);
Builder.createAndAttachToType(FaqTableRow);
/**
 * A table in a FAQ answer with optional column headers.
 *
 * SOURCE FaqTable @ squareup/sub2/assets.proto at 366:1
 */
export const FaqTable = $root.lookupType('squareup.sub2.assets.FaqTable');
fixType(FaqTable);
Builder.createAndAttachToType(FaqTable);
/**
 * An example item in a FAQ answer.
 *
 * SOURCE FaqExampleItem @ squareup/sub2/assets.proto at 376:1
 */
export const FaqExampleItem = $root.lookupType('squareup.sub2.assets.FaqExampleItem');
fixType(FaqExampleItem);
Builder.createAndAttachToType(FaqExampleItem);
/**
 * Examples section in a FAQ answer.
 *
 * SOURCE FaqExamples @ squareup/sub2/assets.proto at 384:1
 */
export const FaqExamples = $root.lookupType('squareup.sub2.assets.FaqExamples');
fixType(FaqExamples);
Builder.createAndAttachToType(FaqExamples);
/**
 * A link within FAQ text.
 *
 * SOURCE FaqLink @ squareup/sub2/assets.proto at 392:1
 */
export const FaqLink = $root.lookupType('squareup.sub2.assets.FaqLink');
fixType(FaqLink);
Builder.createAndAttachToType(FaqLink);
/**
 * A segment of text within an FAQ paragraph, optionally rendered as a link.
 *
 * SOURCE FaqTextSegment @ squareup/sub2/assets.proto at 400:1
 */
export const FaqTextSegment = $root.lookupType('squareup.sub2.assets.FaqTextSegment');
fixType(FaqTextSegment);
Builder.createAndAttachToType(FaqTextSegment);
/**
 * A paragraph in an FAQ answer, composed of text segments.
 *
 * SOURCE FaqParagraph @ squareup/sub2/assets.proto at 408:1
 */
export const FaqParagraph = $root.lookupType('squareup.sub2.assets.FaqParagraph');
fixType(FaqParagraph);
Builder.createAndAttachToType(FaqParagraph);
/**
 * A structured FAQ answer with paragraphs, tables, and examples.
 *
 * SOURCE FaqAnswer @ squareup/sub2/assets.proto at 415:1
 */
export const FaqAnswer = $root.lookupType('squareup.sub2.assets.FaqAnswer');
fixType(FaqAnswer);
Builder.createAndAttachToType(FaqAnswer);
/**
 * A single FAQ item with question and structured answer.
 *
 * SOURCE FaqItem @ squareup/sub2/assets.proto at 424:1
 */
export const FaqItem = $root.lookupType('squareup.sub2.assets.FaqItem');
fixType(FaqItem);
Builder.createAndAttachToType(FaqItem);
/**
 * A feature callout with icon, title, and description.
 *
 * SOURCE FeatureCallout @ squareup/sub2/assets.proto at 432:1
 */
export const FeatureCallout = $root.lookupType('squareup.sub2.assets.FeatureCallout');
fixType(FeatureCallout);
Builder.createAndAttachToType(FeatureCallout);
/**
 * A list of feature callouts specific to a particular plan.
 *
 * SOURCE PlanFeatureCalloutList @ squareup/sub2/assets.proto at 441:1
 */
export const PlanFeatureCalloutList = $root.lookupType('squareup.sub2.assets.PlanFeatureCalloutList');
fixType(PlanFeatureCalloutList);
Builder.createAndAttachToType(PlanFeatureCalloutList);
/**
 * Assets for the Plan Selection page.
 * See: SAAS-4126
 *
 * SOURCE TrialCountdown @ squareup/sub2/assets.proto at 450:1
 */
export const TrialCountdown = $root.lookupType('squareup.sub2.assets.TrialCountdown');
fixType(TrialCountdown);
Builder.createAndAttachToType(TrialCountdown);
/**
 * SOURCE ActivationConfirmation @ squareup/sub2/assets.proto at 462:1
 */
export const ActivationConfirmation = $root.lookupType('squareup.sub2.assets.ActivationConfirmation');
fixType(ActivationConfirmation);
Builder.createAndAttachToType(ActivationConfirmation);
/**
 * SOURCE PreviewBanner @ squareup/sub2/assets.proto at 469:1
 */
export const PreviewBanner = $root.lookupType('squareup.sub2.assets.PreviewBanner');
fixType(PreviewBanner);
Builder.createAndAttachToType(PreviewBanner);
/**
 * A single slide in the Product Tips Modal carousel.
 *
 * SOURCE ProductTipsModalSlide @ squareup/sub2/assets.proto at 477:1
 */
export const ProductTipsModalSlide = $root.lookupType('squareup.sub2.assets.ProductTipsModalSlide');
fixType(ProductTipsModalSlide);
Builder.createAndAttachToType(ProductTipsModalSlide);
/**
 * Variant for the Product Tips Modal, determined by subscription state.
 *
 * SOURCE ProductTipsModalVariant @ squareup/sub2/assets.proto at 497:1
 */
export const ProductTipsModalVariant = $root.lookupEnum('squareup.sub2.assets.ProductTipsModalVariant').values;
/**
 * Assets for the Product Tips Modal carousel.
 * Content is personalized by subaudience and subscription status.
 *
 * SOURCE ProductTipsModal @ squareup/sub2/assets.proto at 512:1
 */
export const ProductTipsModal = $root.lookupType('squareup.sub2.assets.ProductTipsModal');
fixType(ProductTipsModal);
Builder.createAndAttachToType(ProductTipsModal);
/**
 * Assets for the Product Tips Tile card.
 * Uses the same header/description as ProductTipsModal, personalized by subscription state.
 *
 * SOURCE ProductTipsTile @ squareup/sub2/assets.proto at 531:1
 */
export const ProductTipsTile = $root.lookupType('squareup.sub2.assets.ProductTipsTile');
fixType(ProductTipsTile);
Builder.createAndAttachToType(ProductTipsTile);
/**
 * SOURCE PlanSelection @ squareup/sub2/assets.proto at 540:1
 */
export const PlanSelection = $root.lookupType('squareup.sub2.assets.PlanSelection');
fixType(PlanSelection);
Builder.createAndAttachToType(PlanSelection);